import React from 'react'
import { useTranslation } from 'react-i18next'
import * as VPOMMapper from '@carsys/form/src/formbuilder/wholesalers/VPOM/schemaMappers'
import { IProductWithState, OrderFormSchema } from '@cbgms/api'

export const useSchemaMapper = (schema: OrderFormSchema, formData: VPOMMapper.OrderFormData, product: IProductWithState | null) => {
  const { t } = useTranslation()

  return React.useMemo(() => {
    const initialValue = VPOMMapper.initialValueMapper(schema, formData)
    const validationSchema = VPOMMapper.validationMapper(schema, t)
    const sections = VPOMMapper.sectionMapper(schema, product)

    return { sections, validationSchema, initialValue }
  }, [schema, formData])
}
